import {
  CheckFxEligibilityResponse,
  CheckOrCreateOtpResponse,
  CreateOrUpdateUserResponse,
  CreateTaxRefundMemberResponse,
  CREDIT_CARD_BRAND,
  CreditCardStatus,
  CustomerCreditCardResponse,
  GetCountriesResponse,
  GetTaxRefundInfoResponse,
  PAYMENT_METHOD_INDICATION,
  PersonalDetails,
  SendLeadOrSmsResponse,
  StreetsResponse,
  UpdateContactDetailsResponse,
  UpdatePolicyResponse,
  ZipCodeResponse,
  UpdateCCInfoResponse,
  TranslationsResponse,
  DropDown,
  StartOnboardingEnsureResponse,
  PausedActiveRecordingResponse,
  UpdateZipCodeResponse,
} from "src/utils/types";

export const MOCK_DATA_ENABLED = true;

export const MOCK_CHECK_OR_CREATE_OTP_RESPONSE: CheckOrCreateOtpResponse = {
  responseMessage: "success",
  responseCode: "0",
};
export const MOCK_FX_ELIGIBILITY_RESPONSE: CheckFxEligibilityResponse = {
  responseStatus: {
    message: "success",
    code: "200",
  },
  responseData: {
    sessionId: "123456789",
    enableSms: true,
    enableImmediateOnboard: true,
    needToUpdatePhone: false,
    personalId: "123456789",
    last4PhoneDigits: "1234",
    paymentMethodIndication: PAYMENT_METHOD_INDICATION.PERSONAL_ID_MISMATCH,
    sharedLink: "https://www.google.com",
    policyDetails: [
      {
        policyDtoField: {
          travelPolicyNumberField: 12345,
          policyStartDateField: "2024-03-20",
          policyEndDateField: "2024-03-27",
          policyPurchaseDateField: "2024-03-20",
          saleRepresentetiveIDField: 789,
          isAnnualField: false,
          createdByField: 101,
          saleRepresentativeNameField: "Sale Representative Name",
          saleRepresentetiveIdField: 789,
        },
        leadDetailsDtoField: {
          agentIDField: 202,
          leadIDField: 303,
          agentNameField: "Agent Name",
          leadNoteField: "Sample lead note",
          numberOfPassangersField: 2,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "France",
            countryISOField: "FR",
          },
          {
            countryField: "Spain",
            countryISOField: "ES",
          },
          {
            countryField: "Italy",
            countryISOField: "IT",
          },
          {
            countryField: "Germany",
            countryISOField: "DE",
          },
          {
            countryField: "Portugal",
            countryISOField: "PT",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12346,
          policyStartDateField: "2024-04-10",
          policyEndDateField: "2024-04-17",
          policyPurchaseDateField: "2024-04-01",
          saleRepresentetiveIDField: 790,
          isAnnualField: false,
          createdByField: 102,
          saleRepresentativeNameField: "John Smith",
          saleRepresentetiveIdField: 790,
        },
        leadDetailsDtoField: {
          agentIDField: 203,
          leadIDField: 304,
          agentNameField: "Jane Doe",
          leadNoteField: "Family vacation",
          numberOfPassangersField: 4,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Spain",
            countryISOField: "ES",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12347,
          policyStartDateField: "2024-05-15",
          policyEndDateField: "2024-05-22",
          policyPurchaseDateField: "2024-04-30",
          saleRepresentetiveIDField: 791,
          isAnnualField: false,
          createdByField: 103,
          saleRepresentativeNameField: "Robert Johnson",
          saleRepresentetiveIdField: 791,
        },
        leadDetailsDtoField: {
          agentIDField: 204,
          leadIDField: 456,
          agentNameField: "Sarah Miller",
          leadNoteField: "Business trip",
          numberOfPassangersField: 1,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Italy",
            countryISOField: "IT",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12348,
          policyStartDateField: "2024-06-01",
          policyEndDateField: "2025-06-01",
          policyPurchaseDateField: "2024-05-15",
          saleRepresentetiveIDField: 792,
          isAnnualField: true,
          createdByField: 104,
          saleRepresentativeNameField: "Emily White",
          saleRepresentetiveIdField: 792,
        },
        leadDetailsDtoField: {
          agentIDField: 205,
          leadIDField: 306,
          agentNameField: "Michael Brown",
          leadNoteField: "Annual coverage",
          numberOfPassangersField: 2,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Germany",
            countryISOField: "DE",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12349,
          policyStartDateField: "2024-06-10",
          policyEndDateField: "2024-06-17",
          policyPurchaseDateField: "2024-05-25",
          saleRepresentetiveIDField: 793,
          isAnnualField: false,
          createdByField: 105,
          saleRepresentativeNameField: "David Jones",
          saleRepresentetiveIdField: 793,
        },
        leadDetailsDtoField: {
          agentIDField: 206,
          leadIDField: 307,
          agentNameField: "Lisa Wilson",
          leadNoteField: "Summer vacation",
          numberOfPassangersField: 3,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Portugal",
            countryISOField: "PT",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12350,
          policyStartDateField: "2024-07-05",
          policyEndDateField: "2024-07-20",
          policyPurchaseDateField: "2024-06-15",
          saleRepresentetiveIDField: 794,
          isAnnualField: false,
          createdByField: 106,
          saleRepresentativeNameField: "Thomas Clark",
          saleRepresentetiveIdField: 794,
        },
        leadDetailsDtoField: {
          agentIDField: 207,
          leadIDField: 308,
          agentNameField: "Jennifer Taylor",
          leadNoteField: "Group travel",
          numberOfPassangersField: 6,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Greece",
            countryISOField: "GR",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12351,
          policyStartDateField: "2024-08-01",
          policyEndDateField: "2024-08-15",
          policyPurchaseDateField: "2024-07-10",
          saleRepresentetiveIDField: 795,
          isAnnualField: false,
          createdByField: 107,
          saleRepresentativeNameField: "Richard Moore",
          saleRepresentetiveIdField: 795,
        },
        leadDetailsDtoField: {
          agentIDField: 208,
          leadIDField: 309,
          agentNameField: "Patricia Lewis",
          leadNoteField: "Beach holiday",
          numberOfPassangersField: 4,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Netherlands",
            countryISOField: "NL",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12352,
          policyStartDateField: "2024-09-10",
          policyEndDateField: "2024-09-17",
          policyPurchaseDateField: "2024-08-20",
          saleRepresentetiveIDField: 796,
          isAnnualField: false,
          createdByField: 108,
          saleRepresentativeNameField: "Daniel Walker",
          saleRepresentetiveIdField: 796,
        },
        leadDetailsDtoField: {
          agentIDField: 209,
          leadIDField: 310,
          agentNameField: "Barbara Hall",
          leadNoteField: "City break",
          numberOfPassangersField: 2,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Belgium",
            countryISOField: "BE",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12353,
          policyStartDateField: "2024-10-15",
          policyEndDateField: "2024-10-30",
          policyPurchaseDateField: "2024-09-25",
          saleRepresentetiveIDField: 797,
          isAnnualField: false,
          createdByField: 109,
          saleRepresentativeNameField: "Christopher Allen",
          saleRepresentetiveIdField: 797,
        },
        leadDetailsDtoField: {
          agentIDField: 210,
          leadIDField: 311,
          agentNameField: "Elizabeth Young",
          leadNoteField: "Fall getaway",
          numberOfPassangersField: 2,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Croatia",
            countryISOField: "HR",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12354,
          policyStartDateField: "2024-11-20",
          policyEndDateField: "2024-11-27",
          policyPurchaseDateField: "2024-10-30",
          saleRepresentetiveIDField: 798,
          isAnnualField: false,
          createdByField: 110,
          saleRepresentativeNameField: "Matthew King",
          saleRepresentetiveIdField: 798,
        },
        leadDetailsDtoField: {
          agentIDField: 211,
          leadIDField: 312,
          agentNameField: "Susan Wright",
          leadNoteField: "Thanksgiving trip",
          numberOfPassangersField: 5,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Turkey",
            countryISOField: "TR",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12355,
          policyStartDateField: "2024-12-20",
          policyEndDateField: "2025-01-05",
          policyPurchaseDateField: "2024-11-15",
          saleRepresentetiveIDField: 799,
          isAnnualField: false,
          createdByField: 111,
          saleRepresentativeNameField: "Anthony Scott",
          saleRepresentetiveIdField: 799,
        },
        leadDetailsDtoField: {
          agentIDField: 212,
          leadIDField: 313,
          agentNameField: "Karen Green",
          leadNoteField: "Holiday travel",
          numberOfPassangersField: 4,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Austria",
            countryISOField: "AT",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12356,
          policyStartDateField: "2025-01-10",
          policyEndDateField: "2025-01-17",
          policyPurchaseDateField: "2024-12-15",
          saleRepresentetiveIDField: 800,
          isAnnualField: false,
          createdByField: 112,
          saleRepresentativeNameField: "Paul Adams",
          saleRepresentetiveIdField: 800,
        },
        leadDetailsDtoField: {
          agentIDField: 213,
          leadIDField: 314,
          agentNameField: "Nancy Baker",
          leadNoteField: "Winter vacation",
          numberOfPassangersField: 2,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Switzerland",
            countryISOField: "CH",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12357,
          policyStartDateField: "2025-02-01",
          policyEndDateField: "2026-02-01",
          policyPurchaseDateField: "2025-01-15",
          saleRepresentetiveIDField: 801,
          isAnnualField: true,
          createdByField: 113,
          saleRepresentativeNameField: "Mark Carter",
          saleRepresentetiveIdField: 801,
        },
        leadDetailsDtoField: {
          agentIDField: 214,
          leadIDField: 315,
          agentNameField: "Laura Hill",
          leadNoteField: "Annual plan renewal",
          numberOfPassangersField: 3,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Sweden",
            countryISOField: "SE",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12358,
          policyStartDateField: "2025-03-15",
          policyEndDateField: "2025-03-22",
          policyPurchaseDateField: "2025-02-20",
          saleRepresentetiveIDField: 802,
          isAnnualField: false,
          createdByField: 114,
          saleRepresentativeNameField: "Donald Nelson",
          saleRepresentetiveIdField: 802,
        },
        leadDetailsDtoField: {
          agentIDField: 215,
          leadIDField: 316,
          agentNameField: "Sandra Mitchell",
          leadNoteField: "Spring break",
          numberOfPassangersField: 4,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Denmark",
            countryISOField: "DK",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12359,
          policyStartDateField: "2025-04-10",
          policyEndDateField: "2025-04-17",
          policyPurchaseDateField: "2025-03-25",
          saleRepresentetiveIDField: 803,
          isAnnualField: false,
          createdByField: 115,
          saleRepresentativeNameField: "Steven Roberts",
          saleRepresentetiveIdField: 803,
        },
        leadDetailsDtoField: {
          agentIDField: 216,
          leadIDField: 317,
          agentNameField: "Carol Phillips",
          leadNoteField: "Anniversary trip",
          numberOfPassangersField: 2,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Norway",
            countryISOField: "NO",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12360,
          policyStartDateField: "2025-05-20",
          policyEndDateField: "2025-05-27",
          policyPurchaseDateField: "2025-04-30",
          saleRepresentetiveIDField: 804,
          isAnnualField: false,
          createdByField: 116,
          saleRepresentativeNameField: "Kevin Campbell",
          saleRepresentetiveIdField: 804,
        },
        leadDetailsDtoField: {
          agentIDField: 217,
          leadIDField: 318,
          agentNameField: "Ruth Evans",
          leadNoteField: "Graduation trip",
          numberOfPassangersField: 5,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Finland",
            countryISOField: "FI",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12361,
          policyStartDateField: "2025-06-05",
          policyEndDateField: "2025-06-20",
          policyPurchaseDateField: "2025-05-15",
          saleRepresentetiveIDField: 805,
          isAnnualField: false,
          createdByField: 117,
          saleRepresentativeNameField: "Charles Turner",
          saleRepresentetiveIdField: 805,
        },
        leadDetailsDtoField: {
          agentIDField: 218,
          leadIDField: 319,
          agentNameField: "Donna Parker",
          leadNoteField: "Family reunion",
          numberOfPassangersField: 8,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Ireland",
            countryISOField: "IE",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12362,
          policyStartDateField: "2025-07-10",
          policyEndDateField: "2025-07-24",
          policyPurchaseDateField: "2025-06-20",
          saleRepresentetiveIDField: 806,
          isAnnualField: false,
          createdByField: 118,
          saleRepresentativeNameField: "Joseph Collins",
          saleRepresentetiveIdField: 806,
        },
        leadDetailsDtoField: {
          agentIDField: 219,
          leadIDField: 320,
          agentNameField: "Sharon Edwards",
          leadNoteField: "Summer holiday",
          numberOfPassangersField: 3,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "United Kingdom",
            countryISOField: "GB",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12363,
          policyStartDateField: "2025-08-15",
          policyEndDateField: "2025-08-29",
          policyPurchaseDateField: "2025-07-25",
          saleRepresentetiveIDField: 807,
          isAnnualField: false,
          createdByField: 119,
          saleRepresentativeNameField: "Andrew Stewart",
          saleRepresentetiveIdField: 807,
        },
        leadDetailsDtoField: {
          agentIDField: 220,
          leadIDField: 321,
          agentNameField: "Helen Morris",
          leadNoteField: "European tour",
          numberOfPassangersField: 2,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Poland",
            countryISOField: "PL",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12364,
          policyStartDateField: "2025-09-10",
          policyEndDateField: "2025-09-17",
          policyPurchaseDateField: "2025-08-20",
          saleRepresentetiveIDField: 808,
          isAnnualField: false,
          createdByField: 120,
          saleRepresentativeNameField: "Kenneth Rogers",
          saleRepresentetiveIdField: 808,
        },
        leadDetailsDtoField: {
          agentIDField: 221,
          leadIDField: 322,
          agentNameField: "Diane Reed",
          leadNoteField: "Weekend getaway",
          numberOfPassangersField: 2,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Czech Republic",
            countryISOField: "CZ",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12365,
          policyStartDateField: "2025-10-05",
          policyEndDateField: "2025-10-19",
          policyPurchaseDateField: "2025-09-15",
          saleRepresentetiveIDField: 809,
          isAnnualField: false,
          createdByField: 121,
          saleRepresentativeNameField: "Joshua Cook",
          saleRepresentetiveIdField: 809,
        },
        leadDetailsDtoField: {
          agentIDField: 222,
          leadIDField: 323,
          agentNameField: "Frances Morgan",
          leadNoteField: "Fall break",
          numberOfPassangersField: 4,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Hungary",
            countryISOField: "HU",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12366,
          policyStartDateField: "2025-11-15",
          policyEndDateField: "2025-11-22",
          policyPurchaseDateField: "2025-10-25",
          saleRepresentetiveIDField: 810,
          isAnnualField: false,
          createdByField: 122,
          saleRepresentativeNameField: "Ronald Cooper",
          saleRepresentetiveIdField: 810,
        },
        leadDetailsDtoField: {
          agentIDField: 223,
          leadIDField: 324,
          agentNameField: "Deborah Bell",
          leadNoteField: "Business conference",
          numberOfPassangersField: 1,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Slovakia",
            countryISOField: "SK",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12367,
          policyStartDateField: "2025-12-10",
          policyEndDateField: "2025-12-17",
          policyPurchaseDateField: "2025-11-20",
          saleRepresentetiveIDField: 811,
          isAnnualField: false,
          createdByField: 123,
          saleRepresentativeNameField: "Gary Murphy",
          saleRepresentetiveIdField: 811,
        },
        leadDetailsDtoField: {
          agentIDField: 224,
          leadIDField: 325,
          agentNameField: "Dorothy Bailey",
          leadNoteField: "Winter holiday",
          numberOfPassangersField: 3,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Romania",
            countryISOField: "RO",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12368,
          policyStartDateField: "2026-01-05",
          policyEndDateField: "2026-01-19",
          policyPurchaseDateField: "2025-12-15",
          saleRepresentetiveIDField: 812,
          isAnnualField: false,
          createdByField: 124,
          saleRepresentativeNameField: "Raymond Rivera",
          saleRepresentetiveIdField: 812,
        },
        leadDetailsDtoField: {
          agentIDField: 225,
          leadIDField: 326,
          agentNameField: "Judith Cox",
          leadNoteField: "New Year vacation",
          numberOfPassangersField: 4,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Bulgaria",
            countryISOField: "BG",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12369,
          policyStartDateField: "2026-02-10",
          policyEndDateField: "2026-02-17",
          policyPurchaseDateField: "2026-01-20",
          saleRepresentetiveIDField: 813,
          isAnnualField: false,
          createdByField: 125,
          saleRepresentativeNameField: "Dennis Ward",
          saleRepresentetiveIdField: 813,
        },
        leadDetailsDtoField: {
          agentIDField: 226,
          leadIDField: 327,
          agentNameField: "Cynthia Richardson",
          leadNoteField: "Valentine's trip",
          numberOfPassangersField: 2,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Slovenia",
            countryISOField: "SI",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12370,
          policyStartDateField: "2026-03-01",
          policyEndDateField: "2027-03-01",
          policyPurchaseDateField: "2026-02-15",
          saleRepresentetiveIDField: 814,
          isAnnualField: true,
          createdByField: 126,
          saleRepresentativeNameField: "Walter Brooks",
          saleRepresentetiveIdField: 814,
        },
        leadDetailsDtoField: {
          agentIDField: 227,
          leadIDField: 328,
          agentNameField: "Kathleen Watson",
          leadNoteField: "Annual plan",
          numberOfPassangersField: 2,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Estonia",
            countryISOField: "EE",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12371,
          policyStartDateField: "2026-04-05",
          policyEndDateField: "2026-04-12",
          policyPurchaseDateField: "2026-03-15",
          saleRepresentetiveIDField: 815,
          isAnnualField: false,
          createdByField: 127,
          saleRepresentativeNameField: "Gerald Price",
          saleRepresentetiveIdField: 815,
        },
        leadDetailsDtoField: {
          agentIDField: 228,
          leadIDField: 329,
          agentNameField: "Virginia Bennett",
          leadNoteField: "Spring vacation",
          numberOfPassangersField: 3,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Latvia",
            countryISOField: "LV",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12372,
          policyStartDateField: "2026-05-15",
          policyEndDateField: "2026-05-22",
          policyPurchaseDateField: "2026-04-25",
          saleRepresentetiveIDField: 816,
          isAnnualField: false,
          createdByField: 128,
          saleRepresentativeNameField: "Peter Wood",
          saleRepresentetiveIdField: 816,
        },
        leadDetailsDtoField: {
          agentIDField: 229,
          leadIDField: 330,
          agentNameField: "Jean Gray",
          leadNoteField: "Graduation celebration",
          numberOfPassangersField: 6,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Lithuania",
            countryISOField: "LT",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12373,
          policyStartDateField: "2026-06-10",
          policyEndDateField: "2026-06-24",
          policyPurchaseDateField: "2026-05-20",
          saleRepresentetiveIDField: 817,
          isAnnualField: false,
          createdByField: 129,
          saleRepresentativeNameField: "Harold Hughes",
          saleRepresentetiveIdField: 817,
        },
        leadDetailsDtoField: {
          agentIDField: 230,
          leadIDField: 331,
          agentNameField: "Alice Foster",
          leadNoteField: "Summer vacation",
          numberOfPassangersField: 4,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Malta",
            countryISOField: "MT",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12374,
          policyStartDateField: "2026-07-05",
          policyEndDateField: "2026-07-19",
          policyPurchaseDateField: "2026-06-15",
          saleRepresentetiveIDField: 818,
          isAnnualField: false,
          createdByField: 130,
          saleRepresentativeNameField: "Carl Russell",
          saleRepresentetiveIdField: 818,
        },
        leadDetailsDtoField: {
          agentIDField: 231,
          leadIDField: 332,
          agentNameField: "Cheryl Washington",
          leadNoteField: "Island hopping",
          numberOfPassangersField: 2,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Cyprus",
            countryISOField: "CY",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12375,
          policyStartDateField: "2026-08-15",
          policyEndDateField: "2026-08-29",
          policyPurchaseDateField: "2026-07-25",
          saleRepresentetiveIDField: 819,
          isAnnualField: false,
          createdByField: 131,
          saleRepresentativeNameField: "Wayne Fisher",
          saleRepresentetiveIdField: 819,
        },
        leadDetailsDtoField: {
          agentIDField: 232,
          leadIDField: 333,
          agentNameField: "Janet Howard",
          leadNoteField: "Beach vacation",
          numberOfPassangersField: 5,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Iceland",
            countryISOField: "IS",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12376,
          policyStartDateField: "2026-09-10",
          policyEndDateField: "2026-09-17",
          policyPurchaseDateField: "2026-08-20",
          saleRepresentetiveIDField: 820,
          isAnnualField: false,
          createdByField: 132,
          saleRepresentativeNameField: "Roger Martin",
          saleRepresentetiveIdField: 820,
        },
        leadDetailsDtoField: {
          agentIDField: 233,
          leadIDField: 334,
          agentNameField: "Martha Butler",
          leadNoteField: "Wedding trip",
          numberOfPassangersField: 2,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Luxembourg",
            countryISOField: "LU",
          },
        ],
      },
      {
        policyDtoField: {
          travelPolicyNumberField: 12377,
          policyStartDateField: "2026-10-01",
          policyEndDateField: "2027-10-01",
          policyPurchaseDateField: "2026-09-15",
          saleRepresentetiveIDField: 821,
          isAnnualField: true,
          createdByField: 133,
          saleRepresentativeNameField: "Howard Simmons",
          saleRepresentetiveIdField: 821,
        },
        leadDetailsDtoField: {
          agentIDField: 234,
          leadIDField: 335,
          agentNameField: "Kathy Graham",
          leadNoteField: "Annual coverage",
          numberOfPassangersField: 3,
        },
        countryOfDestinationDtoField: [
          {
            countryField: "Monaco",
            countryISOField: "MC",
          },
        ],
      },
    ],
    collectCardInstruction: 1,
    responseMessage: "Success",
    passportCard4LastDigits: "4321",
    responseCode: 0,
    isRiskCountry: false,
    leadButton: false,
  },
};
export const MOCK_GET_PERSONAL_DETAILS_RESPONSE: PersonalDetails = {
  feCustFirstNameHeb: "ישראל",
  feCustLastNameHeb: "ישראלי",
  feCustFirstNameEng: "Israel",
  feCustLastNameEng: "Israeli",
  feCustCountryPhoneCode: "972",
  feCustAreaCode: "054",
  feCustPhone: "1234567",
  feCustEmail: "ariella_cohen@hotmail.com",
  feCustGender: "male",
  feCustStreet: "2232",
  feCustCity: "9000",
  feCustCityName: "באר שבע",
  feCustStreetName: "אשכולית",
  feCustPostalCode: "8415533",
  fePFSmarketingMailing: true,
  feServiceConditionConfirmation: true,
  feHouseNumber: 42,
  feCustHouseNumber: 42,
};
export const MOCK_GET_CC_INFO_RESPONSE: CustomerCreditCardResponse = {
  existingCustomer: true,
  creditCards: [
    {
      feCC4LastDigits: "1111",
      feCustCCExpirationDate: "2025-01-01",
      feCCCardBrand: CREDIT_CARD_BRAND.VISA,
      feCCcardMask: "1234",
      feCustCCStatus: CreditCardStatus.ACTIVE,
      index: 0,
      feCCToken: "1234",
    },
    {
      feCC4LastDigits: "2222",
      feCustCCExpirationDate: "2025-02-02",
      feCCCardBrand: CREDIT_CARD_BRAND.MASTERCARD,
      feCCcardMask: "5678",
      feCustCCStatus: CreditCardStatus.INACTIVE,
      index: 1,
      feCCToken: "1234",
    },
  ],
};
export const MOCK_UPDATE_POLICY_RESPONSE: UpdatePolicyResponse = {
  responseMessage: "success",
  responseCode: "0",
};
export const MOCK_GET_STREETS_RESPONSE: StreetsResponse = {
  responseCode: "0",
  streets: [
    {
      streetId: 1,
      streetName: "אשכולית",
    },
  ],
};

export const MOCK_GET_CITIES_RESPONSE: DropDown[] = [
  {
    id: "1",
    name: "באר שבע",
  },
  {
    id: "2",
    name: "תל אביב",
  },
];
export const MOCK_GET_ZIP_CODE_RESPONSE: ZipCodeResponse = {
  zipCode: "123456789",
};
export const MOCK_UPDATE_ZIP_CODE_RESPONSE: UpdateZipCodeResponse = {
  responseMessage: "success",
  responseCode: "0",
};
export const MOCK_UPDATE_CONTACT_DETAILS_RESPONSE: UpdateContactDetailsResponse =
  {
    responseMessage: "success",
    responseCode: "0",
  };

export const MOCK_CREATE_OR_UPDATE_USER_RESPONSE: CreateOrUpdateUserResponse = {
  responseMessage: "success",
  responseCode: "0",
};
export const MOCK_GET_TAX_REFUND_INFO_RESPONSE: GetTaxRefundInfoResponse = {
  responseMessage: "success",
  responseCode: "0",
  data: {
    feCustPassportNumber: "123456789",
    feCustLastNameEnglish: "Israeli",
    feCustPassportNationality: "Israeli",
    feCustIssuingCountry: "Israel",
    feCustPassportValidity: "2025-01-01",
    fe3rdPartyTaxRefund: true,
    feCustTaxRefundRegistration: false,
    feCustaxRefundEligibility: true,
    feCustFirstNameEnglish: "Israel",
  },
};
export const MOCK_GET_COUNTRIES_RESPONSE: GetCountriesResponse = {
  countries: [
    "Israel",
    "United States",
    "France",
    "Spain",
    "Italy",
    "Germany",
    "Portugal",
    "Greece",
  ],
};
export const MOCK_CREATE_TAX_REFUND_MEMBER_RESPONSE: CreateTaxRefundMemberResponse =
  {
    responseMessage: "success",
    responseCode: "0",
  };
export const MOCK_SEND_LEAD_OR_SMS_RESPONSE: SendLeadOrSmsResponse = {
  responseMessage: "success",
  responseCode: "0",
};
export const MOCK_START_ONBOARDING_ENSURE_RESPONSE: StartOnboardingEnsureResponse =
  {
    responseMessage: "success",
    responseCode: "0",
  };
export const MOCK_PAUSED_ACTIVE_RECORDING_RESPONSE: PausedActiveRecordingResponse =
  {
    responseMessage: "success",
    responseCode: "0",
  };
export const MOCK_UPDATE_CC_INFO_RESPONSE: UpdateCCInfoResponse = {
  creditCards: [
    {
      feCC4LastDigits: "2222",
      feCustCCExpirationDate: "2025-02-02",
      feCCCardBrand: CREDIT_CARD_BRAND.MASTERCARD,
      feCCcardMask: "1234",
      feCustCCStatus: CreditCardStatus.ACTIVE,
    },
    {
      feCC4LastDigits: "1111",
      feCustCCExpirationDate: "2025-01-01",
      feCCCardBrand: CREDIT_CARD_BRAND.VISA,
      feCCcardMask: "5678",
      feCustCCStatus: CreditCardStatus.INACTIVE,
    },
  ],
};
export const MOCK_GET_STRINGS_RESPONSE: any = {
  responseMessage: "success",
  responseCode: "0",
  responseData: {
    strings: {
      code15MessageTitleType1: "אופס, נראה שיש בעיה....",
      code15MessageBodyType1:
        "ראינו  שיש בעיה ברישום לשירות PassportCard Pay נראה כי הבקשה  לרישום אינה תואמת למידע בחברתנו , יש להפנות את הלקוח להמשך בירור מס' טלפון: 09-8920930 מספר מקוצר: 9912* בימים א'-ה' 08:00-18:00 ימים ו' וערבי חג 08:00-13:00",
      code15MessageTitleType2: "אופס, נראה שיש בעיה....",
      code15MessageBodyType2:
        "ראינו  שיש בעיה ברישום לשירות PassportCard Pay נראה כי הבקשה  לרישום אינה תואמת למידע בחברתנו ,  ניתן לפנות אלינו להמשך בירור מס' טלפון: 09-8920930 מספר מקוצר: 9912* בימים א'-ה' 08:00-18:00 ימים ו' וערבי חג 08:00-13:00",
      t_buy_policy_button: "לרכישת ביטוח נסיעות",
      t_fullName: "שם מלא",
      eligibiliryErrorPopupUnsupportedDestination:
        "נראה ששירות PassportCard Pay אינו תומך במדינת היעד שלך. ניתן להצטרף לשירות בנסיעה הבאה. תודה על ההבנה",
      eligibiliryErrorPopupUnsupportedCountry:
        "נראה ששירות ה-PassportCard Pay אינו תומך במדינת היעד של הלקוח, הוא יוכל לפתוח את השירות בנסיעה הבאה. תודה על ההבנה",
      t_click_here: "לחצו כאן",
      loading_page: "מתבצעת טעינת העמוד",
      acc_loading_page: "מִתְבַּצַּעַת טְעִינַת הָעַמוּד",
      t_loader_title: "מעביר נתונים...",
      acc_t_loader_title: "מַעֲבִיר נְתוּנִים...",
      t_loader_description:
        'לידיעתך, שירות PassportCard Pay אינו מוצר ביטוחי. השירות ניתן על ידי PassportCard שירותים פיננסיים בע"מ',
      acc_t_loader_description:
        'לִידִיעָתְּךָ, שֵׁירוּת פַּאסְ פּוֹרְט קַארְד פְּלוּס אֵינוֹ מוּצָר בִּטּוּחִי. הַשֵּׁירוּת נִיתָּן עַל יְדֵי פַּאסְפּוֹרְטְכַּארְד שֵׁירוּתִים פִּינַנְסִיִּים בַּעַ"ם.',
      t_summary_card_instruction_collect:
        '<span>לשימוש הכרטיס בחו"ל עלייך לאסוף כרטיס  PassportCard <a href="https://www.passportcard.co.il/passportcardpickup/" target="_blank" rel="noopener noreferrer">לפרטים</a> </span>',
      acc_t_summary_card_instruction_collect:
        "לְשִׁמּוּשׁ הַכַּרְטִיס בַּחוּ״ל עָלֶיךָ לֶאֱסוֹף כַּרְטִיס פַּאסְ פּוֹרְט קַארְד. לִפְרָטִים: https://www.passportcard.co.il/passportcardpickup/.",
      t_summary_card_instruction_replace:
        '<span>  לשימוש הכרטיס בחו"ל עלייך להחליף את כרטיס sdsdsdsd ב XXXX ה- PassportCard <a href="https://www.passportcard.co.il/passportcardpickup/" target="_blank" rel="noopener noreferrer">לפרטים</a> </span>',
      acc_t_summary_card_instruction_replace:
        "לְשִׁמּוּשׁ הַכַּרְטִיס בַּחוּ״ל עָלֶיךָ לְהַחְלִיף אֶת הַכַּרְטִיס הַמִּסְתַּיֵּם ב־XXXX בפַּאסְ פּוֹרְט קַארְד. לִפְרָטִים: https://www.passportcard.co.il/passportcardpickup/",
      t_global_blue_not_supported_country:
        'המדינה שאליה אתה טס אינה תומכת בשירות החזרי מע"מ',
      t_global_blue_already_registered:
        "אנחנו מזהים כי הנך כבר רשום לשירות - לקבלת ברקוד יש לפנות לחברת GB בלינק הבא: www.globalblue.com",
      t_error_popup_page_not_found_title: "אופס! נראה שהגעת לדף לא קיים…",
      t_error_popup_page_not_found_body:
        "אבל אל תדאג, זה קורה לטובים ביותר! נסה לבדוק שוב את הכתובת או פשוט לחזור אחורה.",
      t_towards_step: "לשלב",
      acc_t_towards_step: "לַשָּׁלָב",
      t_toggle_step_open: "פתיחת שלב זה",
      acc_t_toggle_step_open: "פְּתִיחַת שָׁלָב זֶה",
      t_toggle_step_close: "סגירת שלב זה",
      acc_t_toggle_step_close: "סְגִירַת שָׁלָב זֶה",
      acc_t_toggle_step_disabled:
        "שָׁלָב לֹא נִיתָּן לִפְתִּיחָה, יֵשׁ לְמַלֵּא אֶת הַשָּׁלָב הַקּוֹדֵם",
      t_active_credit_how_it_works: "איך זה עובד ?",
      t_active_credit_title:
        "כדי לבצע את חיובי האשראי בחו״ל דרך כרטיס הפספורטכארד, עלינו לקשר אותו עם אחד מכרטיסי האשראי הקיימים שלך.",
      t_active_credit_sub_title:
        "התנאים וההטבות בכרטיסך יישמרו, אבל החיוב מהכרטיס ייעשה רק אחרי שאנחנו נמיר עבורך את העסקה לשקלים ונחסוך עבורך את העמלות בדרך.",
      t_active_credit_more_info: "לכל השאלות והתשובות",
      acc_t_active_credit_more_info: "לְכָל הַשְּׁאֵלוֹת וְהַתְּשׁוּבוֹת",
      t_active_credit_choose_payment_method: "הוספת אמצעי תשלום",
      acc_t_active_credit_choose_payment_method:
        "בְּחִירַת אַמְצָעִי תַּשְׁלוּם",
      t_active_credit_last_card: "כרטיס אחרון שחויב",
      acc_t_active_credit_last_card: "כַּרְטִיס אַחֲרוֹן שֶׁחוּיַּב",
      t_active_credit_saved_cards: "כרטיסים שמורים אחרונים",
      t_active_credit_add_other_payment: "החלפת אמצעי תשלום",
      t_active_credit_replace_other_payment: "הוספת אמצעי תשלום",
      acc_t_active_credit_add_other_payment:
        "הוֹסָפַת אַמְצָעִי תַּשְׁלוּם אַחֵר",
      t_active_credit_accept: "אני מאשר שקראתי את ",
      acc_t_active_credit_accept: "אֲנִי מְאַשֵּׁר שֶׁקָּרָאתִי אֶת",
      t_active_credit_terms: "תנאי השימוש",
      acc_t_active_credit_terms: "תַּנָּאֵי הַשִּׁימוּשׁ",
      t_active_credit_checkbox_text: " והם סבבה לגמרי",
      acc_t_active_credit_checkbox_text: "וְהֵם סַבָּבָּה לְגַמְרֵי",
      t_active_credit_next_disabled:
        "על מנת להמשיך יש למלא את השדות הנדרשים תחילה",
      acc_t_active_credit_next_disabled:
        "עַל מְנַת לְהַמְשִׁיךְ יֵשׁ לְמַלֵּא אֶת הַשָּׂדוֹת הַנִּדְרָשִׁים תְּחִילָה",
      t_active_credit_next: "להרשמה",
      t_card_item_card_number: "מספר כרטיס",
      t_card_item_expiration_date: "תוקף",
      t_tax_refaund_how_it_works: "לתשומת לבך!",
      t_tax_refaund_title:
        "על מנת שיהיה ניתן להירשם כלקוח Global Blue יש להזין את הפרטים - <b>בדיוק</b> כמו בדרכון. בסיום הרישום, הברקוד להצגה בחנויות יחכה לך באפליקציה.",
      t_tax_refaund_more_info: "שאלות והתשובות",
      acc_t_tax_refaund_more_info: "לְכָל הַשְּׁאֵלוֹת וְהַתְּשׁוּבוֹת.",
      t_tax_refaund_more_info_aria_label: "לכל השאלות והתשובות",
      t_tax_refaund_banner_title: "לתשומת לבך!",
      t_tax_refaund_banner_sub_title:
        "ביעד הנוכחי של הנסיעה שלך אין אפשרות להפעיל שירות החזר מע״מ. השירות יוכל לשמש אותך בנסיעות הבאות.",
      t_tax_refaund_info_to_register: "הפרטים להרשמה לשירות",
      t_tax_refaund_info_to_register_sub_title:
        "אם אין ברשותך את הפרטים בשלב זה - אפשר להמשיך בהרשמה ולהשלים אותם מאוחר יותר דרך האפליקציה. פרטים להורדת האפליקציה יישלחו לאחר ההרשמה.",
      t_tax_refaund_info_passport_number: "מספר דרכון",
      acc_t_tax_refaund_info_passport_number: "מִסְפַּר דַּרְכּוֹן",
      t_tax_refaund_expiration_date: "תוקף",
      t_tax_refaund_expiration_date_text_aria: "תוקף",
      acc_t_tax_refaund_expiration_date_text_aria: "תוֹקֵף",
      t_tax_refaund_state_of_issue: "מדינת הנפקת הדרכון",
      acc_t_tax_refaund_state_of_issue: "מְדִינַת הַנְפָּקַת הַדַּרְכּוֹן",
      t_tax_refaund_nation: "לאום",
      acc_t_tax_refaund_nation: "לְאוֹם",
      t_tax_refaund_next: "השלמת הרשמה",
      acc_t_tax_refaund_next: "הַשְׁלָמַת הַרְשָׁמָה",
      t_tax_refaund_error_message:
        "הפרטים שהזנת אינם תקינים. אם הפרטים אינם זמינים לך - אפשר לבחור באפשרות ״המשך בלי להשלים את הפרטים״ ולהשלים אותם  מאוחר יותר",
      t_tax_refaund_edit: "עריכה",
      t_tax_refaund_pass_num: "דרכון מס׳",
      t_tax_refaund_tokef: "תוקף",
      t_update_contact_main_title:
        "יש לאשר את פרטי הקשר שיש ברשותנו ולהשלים את פרטי הכתובת.",
      t_update_contact_phone: "מספר טלפון",
      t_update_contact_edit: "עריכה",
      t_update_contact_phone_edit: "עריכת מספר טלפון",
      acc_t_update_contact_phone_edit: "עֲרִיכַת מִסְפַּר טֶלֶפוֹן",
      t_update_contact_email_title: "כתובת מגורים",
      acc_t_update_contact_email_title: "כְּתוֹבֶת מְגוּרִים",
      t_update_contact_email_title_wrapper: "דואר אלקטרוני",
      acc_t_update_contact_email_title_wrapper: "דּוֹאַר אֵלֶקְטְרוֹנִי",
      t_update_contact_address_placeholder: "רחוב",
      acc_t_update_contact_address_placeholder: "רְחוֹב",
      t_update_contact_zip: "מיקוד",
      acc_t_update_contact_zip: "מִיקּוּד",
      t_update_contact_checkbox_text:
        "ידוע לי שפרטיי ישמשו לצורך משלוח הודעות על חידושים והטבות בשירותי PassportCard Pay ואני מסכים/ה לכך.",
      acc_t_update_contact_checkbox_text:
        "ידוע לי שפרטיי ישמשו לצורך משלוח הודעות על חידושים והטבות בשירותי PassportCard Pay ואני מסכים/ה לכך.",
      t_update_contact_save: "המשך",
      t_benefits_update_contact_info: "עדכון פרטים אישיים",
      t_benefits_enable_card: "חיבור כרטיס האשראי",
      acc_t_benefits_enable_card: "חִיבּוּר כַּרְטִיס הָאַשְׁרַאי",
      t_benefits_accordion_title: "הצטרפות לשירות החזר מע״מ (Tax Refund)",
      t_benefits_title: "הצטרפות לשירות PassportCard Pay",
      acc_accordion_not_allowed: "..... שלב זה אינו מאופשר",
      acc_t_benefits_title:
        "הַצְטָרְפוּת לַשֵּׁירוּת פַּאסְ פּוֹרְט קַארְד פְּלוּס",
      t_update_contact_validation_required: "שדה חובה",
      t_update_contact_validation_wrong_zip: "מיקוד לא תקין",
      t_update_contact_validation_wrong_email: "המייל שהזנת לא תקין",
      t_update_contact_validation_short_address: "כתובת קצרה מדי",
      t_leads_transferring_title: "נציג יקר - איך תרצה להמשיך?",
      t_leads_transferring_sub_title:
        "הלקוח מעוניין להצטרף לשירות , יש לבחור את אופן ההצטרפות שסוכם עם הלקוח בשיחה",
      t_leads_transferring_what_next: "איך ממשיכים מכאן ?",
      t_leads_transferring_title1: "המשך ישיר מול הלקוח",
      t_leads_transferring_sub_title1:
        "מעבר לתהליך הצטרפות ופתיחת הכרטיס לשימושים בחו׳׳ל",
      t_leads_transferring_title2: "שליחת ליד למוקד הטלפוני",
      t_leads_transferring_sub_title2:
        "העברת ליד למוקד PassportCard Pay לחזרה טלפונית",
      t_leads_transferring_title3: "שליחת הודעת SMS ללקוח",
      t_leads_transferring_sub_title3:
        "הצטרפות עצמית של הלקוח באמצעות תהליך דיגיטלי",
      t_leads_transferring_success_message: "יש לנו את זה!",
      t_leads_transferring_success_message_sub_title: "הליד נשלח למוקד!",
      t_sms_transferring_success_message: "יש לנו את זה!",
      t_sms_transferring_success_message_sub_title: "הודעת SMS נשלחה ללקוח",
      t_tax_refaund_validation_required: "שדה חובה",
      t_login_title: "כיף לראות אותך",
      acc_t_login_title: "כֵּיף שֶׁבָּאתָ שׁוּב!",
      t_login_sub_title: "נשמח לזהות אותך ",
      acc_t_login_sub_title: "נִשְׂמַח לְזַהוֹת אוֹתְךָ",
      t_login_id: "מספר תעודת זהות",
      t_login_id_error_message: "מספר תעודת זהות לא תקין",
      t_login_phone: "מספר טלפון",
      t_login_phone_error_message: "מספר טלפון לא תקין",
      t_login_checkbox_text:
        "אני מאשר העברת המידע שלי לחברת פספורטכארד שירותים פיננסים",
      t_login_checkbox_text_link: "ולתנאי הפעילות",
      t_login_button: "המשך",
      t_otp_subTitle: "שלחנו לך קוד ב-SMS",
      acc_t_otp_subTitle: "שְׁלַחֲנוּ לְךָ קוּד בְּאֶס אֶם אֶס",
      t_otp_placeholder: "מה הקוד שקיבלת (6 ספרות)",
      t_otp_placeholder_info: "הקוד נשלח לנייד שמסתיים ב- ",
      t_opt_error_message: "קוד לא תקין",
      t_choose_policy_title: "על איזה פוליסה מדובר?",
      acc_t_choose_policy_title: "עַל אֵיזוֹ פוֹלִיסָה מְדֻבָּר?",
      t_choose_policy_sub_title: "יש לבחור את הפוליסה הרלוונטית",
      acc_t_choose_policy_sub_title:
        "יְשׁ לְבַחַר אֶת הַפּוּלִיסָה הָרְלוּוּנְטִית",
      t_choose_policy_destination: "יעד",
      t_choose_passengers: "נוסעים",
      t_choose_policy_dates: "תאריכים",
      t_active_credit_banner_title: "לתשומת לבך!",
      acc_t_active_credit_banner_title: "לִתְשׂוּמַת לִבְּךָ!",
      t_active_credit_banner_sub_title:
        "יש להוסיף כרטיס אשראי שמשויך לתעודת הזהות שאיתה נרשמת לפספורטכארד.",
      acc_t_active_credit_banner_sub_title:
        "יֵשׁ לְהוֹסִיף כַּרְטִיס אַשְׁרַאי שֶׁמְּשוּיָּךְ לִתְּעוּדַת הַזֶּהוּת שֶׁאִיתָהּ נִרְשַׁמְתָּ לְפַּאסְ פּוֹרְט קַארְד.",
      t_active_credit_banner_sub_title_second_part:
        "הוספת הכרטיס אינה מייצרת כל חיוב ותשרת אך ורק את רכישות עתידיות שיבוצעו בחו״ל עם כרטיס הפספורטכארד שלך.",
      acc_t_active_credit_banner_sub_title_second_part:
        "הוֹסָפַת הַכַּרְטִיס אֵינָה מְיַיצֶּרֶת כָּל חִיּוּב וְתְשַׁמֵּשׁ אַךְ וְרַק לִרְכִישוֹת עֲתִידִיּוֹת שֶׁיְּבוּצְעוּ בַּחוּ״ל עִם כַּרְטִיס הַפַּאסְ פּוֹרְט קַארְד שֶׁלְּךָ.",
      t_send_again: "שלחו לי שוב",
      t_back: "< חזרה",
      t_back_button_benefits: "חזרה > ",
      acc_t_back: "חֲזָרָה",
      t_login_first_name_error_message: "יש לרשום באנגלית",
      t_login_last_name_error_message: "יש לרשום באנגלית",
      t_login_first_name: "שם פרטי באנגלית",
      acc_t_login_first_name: "שֵׁם פְּרָטִי בְּאַנְגְּלִית",
      t_login_last_name: "שם משפחה באנגלית",
      acc_t_login_last_name: "שֵׁם מִשְׁפָּחָה בְּאַנְגְּלִית",
      t_error_popup_cant_move_title: "נראה שלא ניתן להמשיך בתהליך...",
      t_error_popup_cant_move_body:
        "לא ניתן להמשיך בתהליך. יש לפנות למוקד השירות בטלפון 1234*.",
      t_error_popup_cant_move_button: "סגירה",
      t_error_popup_debt_title: "נראה שיש חוב פתוח",
      t_error_popup_debt_body:
        "לא ניתן להמשיך בתהליך. יש לפנות למוקד השירות בטלפון 1234*.",
      t_error_popup_debt_button: "סגירה",
      t_error_popup_cant_find_title: "לא איתרנו פוליסת ביטוח נסיעות פעילה",
      t_error_popup_cant_find_body:
        "לא ניתן להמשיך בתהליך. יש לפנות למוקד השירות בטלפון *1234 או למלא את הפרטים להלן כדי שנוכל לחזור אליך בהקדם האפשרי.",
      t_error_popup_cant_find_button: "סגירה",
      t_summary_title: "שירות PassportCard Pay  הופעל בכרטיסך!",
      acc_t_summary_title:
        "שֵׁרוּת פַּאסְ פּוֹרְט קַארְד פְּלוּס הוּפְעַל בְּכַּרְטִיסְךָ!",
      t_summary_sub_title:
        "זה הזמן להעביר את כרטיס הפספורטכארד שלך לארנק הפרטי והדיגיטלי של {gpay} ו- {apay}. מעכשיו הכרטיס ישמש אותך לכל הרכישות בחו״ל.",
      t_summary_sub_title_question: "נתחיל לשלם כמו מקומיים?",
      acc_t_summary_sub_title_question:
        "נִתְחִיל לְשַלֵּם כְּמוֹ מְקוֹמִיִּים?",
      acc_t_summary_sub_title:
        "זֶה הַזְּמַן לְהַעֲבִיר אֶת כַּרְטִיס הַפַּאסְ פּוֹרְט קַארְד שֶׁלְּךָ לְאַרְנָק הַפְּרָטִי וְהַדִּיגִיטָלִי שֶׁל גוּגְּל פֵּיי וְ אַפֶּּּל פֵּיי..... מֵעַכְשָׁיו הַכַּרְטִיס יְשַׁמֵּשׁ אוֹתְךָ לְכָל הָרְכִישׁוֹת בַּחוּ״ל.....\nשֶׁנַּתְחִיל לְשַלֵּם כְּמוֹ מְקוֹמִיִּים?",
      t_summary_body: "מכאן ממשיכים להורדת האפליקציה",
      acc_t_summary_body: "מִכָּאן מַמְשִׁיכִים לְהוֹרָדַת הָאֲפְּלִיקַצְיָה.",
      t_summary_description:
        "סרקו את הקוד או חפשו PassportCard IL בחנויות האפליקציות.",
      t_summary_description_mobile: "חפשו PassportCard IL בחנויות האפליקציות",
      acc_t_summary_description_mobile:
        "חפשו PassportCard IL בחנויות האפליקציות",
      acc_t_summary_description:
        "סִרְקוּ אֶת הַקוֹד אוֹ חַפְּשׂוּ PassportCard IL בַּחֲנוּיוֹת הָאֲפְּלִיקַצְיוֹת.",
      t_summaty_footer_text1:
        "ברשותך כרטיס PassportCard מספר XXXX פעיל מנסיעותייך הקודמות חשוב לקחת אותו לנסיעתך הקרובה.",
      acc_t_summaty_footer_text1:
        "בִּרְשׁוּתְךָ כַּרְטִיס פַּאסְ פּוֹרְט קַארְד מִסְפָּר XXXX פָּעִיל מִנְּסִיעוֹתֶיךָ הַקּוֹדְמוֹת. חָשׁוּב לָקַחַת אוֹתוֹ לִנְסִיעָתְּךָ הַקְּרוֹבָה.",
      t_summaty_footer_text2:
        " מידע נוסף על השירות נשלח אליך במייל ובהודעת SMS.",
      acc_t_summaty_footer_text2:
        "מֵידָע נוֹסָף עַל הַשֵּׁרוּת נִשְׁלַח אֵלֶיךָ בְּמֵייל וּבְהוֹדָעַת אֶס אֶם אֶס.",
      t_summaty_footer_text3:
        "להפעלת הכרטיס וקבלת הקוד הסודי יש להוריד את האפליקציה.",
      acc_t_summaty_footer_text3:
        "לְהַפְעָלַת הַכַּרְטִיס וּקְבִלַּת הַקוֹד הַסּוֹדִי יֵשׁ לְהוֹרִיד אֶת הָאֲפְּלִיקַצְיָה.",
      t_addon_one_title: "הרשמה לשירות Flight delay - כניסה לטרקלין",
      t_addon_one_body:
        "תנו לנו לארח אתכם בטרקלין בכל עיכוב של מעל 90 דקות בטיסה. השירות ללא תשלום אבל מחייב הרשמה מראש.",
      t_addon_two_title: "הרשמה לחבילת eSim - שיחות ואינטרנט 15GB ללא תשלום",
      t_addon_two_body: "חבילה חינמית של 15GB ואפשרות הרחבה בעלות נמוכה במיוחד",
      t_addon_three_title: "רכישת מט״ח או משהו",
      t_addon_three_body:
        "פעילות עתידית שתאפשר פתרונות פיננסיים ללקוח רלוונטיים לנסיעה.",
      t_addon_one_btn: "להפעלת השירות",
      t_addon_two_btn: "להרשמה לשירות",
      t_addon_three_btn: "להרשמה לשירות",
      t_summary_button: "להורדת האפליקציה",
      acc_t_summary_button: "לְהוֹרָדַת הָאֲפְּלִיקַצְיָה.",
      t_summary_mobile_title: "להורדת האפליקציה לחצו על הכפתור למטה",
      acc_t_summary_mobile_title:
        "לְהוֹרָדַת הָאֲפְּלִיקַצְיָה לָחֲצוּ עַל הַכַּפְתּוֹר לְמַטָּה.",
      t_digiral_agent_title: "סוכן יקר - איך תרצה להמשיך?",
      t_digiral_agent_body:
        "אנחנו שמחים שממשיכים שבחרת לקדם את האפשרות לחבר את כרטיס הפספורטכארד לרכישות אשראי. נוכל לחסוך ללקוח שלך עמלות וגם לקצר את הדרך לקבלת החזרי מע״מ. ",

      t_digiral_agent_list_title: "יש שתי אפשרויות להתקדם מכאן:",
      t_digital_agent_item1_title:
        "השארת ליד למוקד, כדי שהנציגים שלנו יצרו קשר וימשיכו מול הלקוח",
      t_digital_agent_item2_title:
        "העתקת קישור לשליחה ללקוח, שיאפשר המשך רכישה עצמאית",
      t_digital_agent_list_sub_title: "איך תרצה להתקדם?",
      t_digital_agent_contact_button: "השארת ליד למוקד",
      t_digital_agent_send_button: "לינק רכישה לשיתוף",
      t_digital_agent_dissmis_button: "לכל הטבות >",
      t_digital_agent_dissmis_button_aria_label: "לכל הטבות",
      t_faq_credit_card_title: "הפעלת כרטיס אשראי - כל מה שצריך לדעת",
      t_faq_credit_card_sub_title: "איך זה עובד ?",
      t_faq_credit_card_body:
        "הפעלת כרטיס האשראי תהפוך את הפספורטכארד שלך לכרטיס שדרכו כדאי לך לבצע את הרכישות בחו״ל. הרכישות דרך הכרטיס יחסכמו לך בעמלה ויאפשרו לך לקבל החזרי מע״מ בקלות.",
      t_faq: "שאלות ותשובות",
      t_faq_credit_card_question_one: "כמה עולה השירות ?",
      t_faq_credit_card_question_two: "מה עמלת ההמרה שאני משלם ?",
      t_faq_credit_card_question_three:
        "האם ניתן להשתמש בכרטיס PassportCard לקניות באינטרנט ?",
      t_faq_credit_card_question_four:
        "למה להשתמש בכרטיס PassportCard ולא באשראי הפרטי ? ",
      t_faq_credit_card_question_five: "האם הכרטיס תופס מסגרת אשראי ?",
      t_faq_credit_card_answer_one:
        "השירות ניתן ללא עלות למעט עמלת המרת מט״ח אטרקטיבית וללא עמלות נסתרות, לינק לתעריפי השירות.",
      t_faq_credit_card_answer_two:
        "עמלת ההמרה היחידה היא 1.75% מסכום הפעולה המחושב בהתאם לשער ההמרה היציג המתפרסם ע״י בנק ישראל, הידוע במועד קליטת הפעולה במחשבינו, ואם אין למטבע שבו מתבצעת הפעולה שער המרה יציג או שההמרה מבוצעת ממטבע שאינו שקל חדש – בהתאם לשער הרציף שצוטט עבורנו על ידי בנק. לדוגמא : התחדשתי בנעליים חדשות בסכום של 100 אירו. שער האירו היציג הוא 4 ש״ח, ולכן אשלם 407 ₪ עמלה של 1.75% בלבד שהם 7 ₪.",
      t_faq_credit_card_answer_three:
        "איך אפשר בלי קניות Online? כמובן, ניתן להשתמש בכרטיס לקניות באינטרנט בתקופת הנסיעה.",
      t_faq_credit_card_answer_four:
        "באמצעות כרטיס ה- PassportCard אנחנו נדאג לתשלום במטבע המקומי וכך ניתן להנות משער המרה אטרקטיבי. החיוב שיופיע בכרטיסכם הפרטי יהיה בשקלים בלבד, ללא עמלות נסתרות וחיובים שצצים באשראי בזמן השהות שלכם בחו״ל. אצלנו אפשר להנות כתייר, לשלם כמקומי ולחזור בפלוס מהנסיעה.",
      t_faq_credit_card_answer_five:
        "לא. כרטיס PassportCard אינו תופס מסגרת אשראי, אך הוא מסתמך על המסגרת בכרטיס האשראי הפרטי המשויך לשירות.",
      t_faq_credit_card_button: "סגירה",
      t_tax_refaund_popup_title: "החזרי מע״מ - כל מה שצריך לדעת",
      t_tax_refaund_popup_sub_title: "איך זה עובד?",
      t_tax_refaund_popup_body:
        "בעת הרכישה בחו״ל, ניתן יהיה לבצע רכישות באמצעות הפספורטכארד בעמדות מתאימות. בשדה התעופה בעמדת החזר המע״מ תוכלו לסרוק את קוד החיובים ולחכות פחות בתור.",
      t_tax_refauld_popup_faq: "שאלות ותשובות",
      t_tax_refaund_popup_button: "סגירה והמשך",
      t_tax_refaund_popup_question_one: "איך נרשמים לספק החזר המע״מ?",
      t_tax_refaund_popup_question_two: "איך מקבלים החזר מע״מ?",
      t_tax_refaund_popup_question_three:
        "באילו מדינות שירות החזר המע״מ של PassportCard Pay פעיל?",

      t_tax_refaund_popup_answer_one:
        "ניתן להירשם לספק החזר המע״מ במהלך ההצטרפות לשירות PassportCard Pay  במידה ופרטי הדרכון שלכם עליכם. במידה ולא, ניתן להירשם לאחר מכן באמצעות האפליקציה. לאחר הרישום לשירות יתקבל ברקוד אותו יש להציג בחנויות השונות שעובדות עם ספק החזרי המע״מ אליו נרשמת ולא לשכוח לבקש את טופס ה- Tax free מהחנות.",
      t_tax_refaund_popup_answer_two:
        "הליך החזר המע״מ נקבע על ידי כל מדינה ומדינה לפי חוקיה. יום לפני החזרה לארץ אנחנו נדאג לשלוח את כל מה המידע הנדרש לעשות ולאן ללכת בשדה התעופה כדי לבצע את הליך החזרי המע״מ. אל דאגה לא צריך לזכור כלום - אנחנו נדאג לתזכר לקראת החזרה הביתה.",
      t_tax_refaund_popup_answer_three:
        "נכון להיום, שירות החזר מע״מ פעיל במדינות הבאות: אוסטריה, איטליה ,אירלנד ,בלגיה ,גרמניה ,הולנד ,הונגריה ,יוון ,ספרד פולין ,פורטוגל ,צ׳כיה ,צרפת ,קפריסין ,קרואטיה ,שבדיה ,שוויץ.",
      t_city: "עיר",
      acc_t_city: "עִיר",
      t_apartment: "מספר בית",
      acc_t_apartment: "מִסְפַּר בַּיִת",
      t_summary_dgeshim: "דגשים שחשוב לדעת:",
      acc_t_summary_dgeshim: "דְּגָשִׁים שֶׁחָשׁוּב לָדַעַת:",
      t_summary_dgeshim_qr: "ברקוד לסריקה",
      t_why_we_need_adress:
        "אנחנו צריכים גם את הכתובת הפיזית שלך בשל דרישות רגולציה שחלות עלינו כמוסד פיננסי.",
      acc_t_why_we_need_adress:
        "אֲנַחְנוּ צְרִיכִים גַּם אֶת הַכְּתוֹבֶת הַפִּיזִּית שֶׁלְּךָ בִּשְׁלִי דְּרִישּׁוֹת רֵגוּלַצְיָה שֶׁחוֹלוֹת עָלֵינוּ כְּמוֹסָד פִּינַּנְסִי.",
      t_active_credit_card_error:
        'הכרטיס שרכשת איתו את פוליסת הביטוח אינו יכול לשמש אותך לשירותי המט"ח מאחר ותוקפו יפוג במהלך תקופת הנסיעה, אנא בחר כרטיס אחר או הוסף כרטיס חדש',
      acc_t_active_credit_card_error:
        "הַכַּרְטִיס שֶׁרָכַשְׁתָּ אִיתוֹ אֶת פּוֹלִיסַת הַבִּיטּוּחַ אֵינוֹ יָכוֹל לְשַׁמֵּשׁ אוֹתְךָ לְשֵׁירוּתֵי הַמַּטְ״ח מֵאַחַר וּתוֹקְפּוֹ יִפֹּג בְּמַהֲלַךְ תְּקוּפַּת הַנְּסִיעָה.  אָנָּא בְּחַר כַּרְטִיס אַחֵר אוֹ הוֹסֵף כַּרְטִיס חָדָשׁ.",
      t_active_credit_date_error:
        'הכרטיס שרכשת איתו את פוליסת הביטוח אינו יכול לשמש אותך לשירותי המט"ח מאחר והשירות תומך רק בכרטיסים מסוג ויזה או מאסטרקארד, אנא בחר כרטיס אחר או הוסף כרטיס חדש',
      t_backToBenefits: "לכל ההטבות > ",
      acc_t_backToBenefits: "לְכָל הַהַטָּבוֹת",
      t_digital_fail_message:
        "לא ניתן להמשיך בתהליך. יש לפנות למוקד השירות בטלפון 1234*.",
      t_share_title: "חיבור כרטיס פספורטכארד לרכישות אשראי",
      t_share_text:
        "נוכל לחסוך לך עמלות ולקצר את הדרך לקבלת החזרי מע״מ. לחץ על הקישור כדי להמשיך בתהליך באופן עצמאי.",
      t_popupTitleError: "משהו השתבש...",
      t_popupTextHelpMarketing:
        "אל דאגה אנחנו כאן כדאי לעזור,\nיש ליצור איתנו קשר בכל דרך שנוחה לך ואנחנו נפתור את הבעיה בהקדם\nבטלפון *9912 financialservices@passportcard.co.il אנו זמינים עבורך במייל\nתודה על ההבנה",
      t_popupTextHelpLead:
        "אל דאגה אנחנו כאן כדאי לעזור,\nיש להנחות את הלקוח ליצור איתנו קשר בכל דרך שנוחה לך ואנחנו נפתור את הבעיה בהקדם\nבטלפון *9912 financialservices@passportcard.co.il אנו זמינים עבורך במייל\nתודה על ההבנה",
      t_errorTitleDebt: "נראה שיש חוב פתוח",
      t_errorTextDebtMarketing:
        "אנחנו מזהים חוב פתוח ברשותך\nיש ליצור איתנו קשר בכל דרך שנוחה לך ואנחנו נפתור את הבעיה בהקדם\nבטלפון *9912 financialservices@passportcard.co.il\nתודה על ההבנה",
      t_errorTextDebtLead:
        "אנחנו מזהים שיש חוב פתוח ברשות הלקוח\nיש להפנות את הלקוח ליצור איתנו קשר בכל דרך שנוחה לך ואנחנו נפתור את הבעיה בהקדם\nבטלפון *9912 financialservices@passportcard.co.il\nתודה על ההבנה",
      t_wrongId: "יש להזין תעודת זהות תקינה",
      t_popupTitleNoInsuranceMarketing: "אויש, אין לך ביטוח בתוקף",
      t_popupTextNoInsuranceMarketing:
        'לרכישת פוליסת ביטוח נסיעות לחו"ל ולהירשמות לשירות PassportCard Pay ניתן להתקשר למוקד המכירות: *9921',
      t_popupTextNoInsuranceLead:
        'למבוטחים בלבד בשלב זה ניתן להצטרף לשירות PassportCard Local\nלינק לרכישת ביטוח: רכישת ביטוח נסיעות לחו"ל פספורטכארד (passportcard.co.il)\nתודה על ההבנה',
      t_popupTitleCustomerNotFound: "אויש, הלקוח לא קיים במערכת",
      t_popupTextCustomerNotFound:
        'למבוטחים בלבד בשלב זה ניתן להצטרף לשירות PassportCard Local\nלינק לרכישת ביטוח: רכישת ביטוח נסיעות לחו"ל פספורטכארד (passportcard.co.il)\nתודה על ההבנה',
      t_popupTitleServiceNotAvailable: "לצערנו לא נוכל להתקדם",
      t_popupTextServiceNotAvailable:
        "בשלב זה השירות אינו זמין ללקוחות בפוליסה שנתית\nתודה על ההבנה",
      t_popupTitleAgeRestriction: "השירות הינו מגיל 18",
      t_popupTextAgeRestriction:
        "השירות זמין למשתמשים החל מגיל 18\nתודה על ההבנה",
      t_popupTitleAlreadyRegisteredMarketing: "איזה כיף כבר נרשמת לשירות",
      t_popupTextAlreadyRegisteredMarketing:
        "שמנו לב שהצטרפת לשירות\nבטלפון *9912 financialservices@passportcard.co.il אנו זמינים עבורך במייל\nתודה על ההבנה",
      t_popupTitleAlreadyRegisteredLead: "הלקוח כבר רשום לשירות",
      t_popupTextAlreadyRegisteredLead:
        "נראה שהלקוח כבר הצטרף לשירות\nבטלפון *9912 financialservices@passportcard.co.il אנו זמינים עבורך במייל\nתודה על ההבנה",
      t_popupTitleMissingDetailsMarketing:
        "לצערנו לא ניתן להמשיך בתהליך. זיהינו שמספר הטלפון חסר",
      t_popupTextMissingDetailsMarketing:
        "את מספר הטלפון יש לעדכן באתר באזור האישי https://app.passportcard.co.il/*9912 או באמצעות נציג בטלפון \nתודה על ההבנה",
      t_popupTitleMissingDetailsLead: "חסרים פרטים אישיים",
      t_popupTextMissingDetailsLead:
        "לצערנו לא ניתן להמשיך בתהליך. זיהינו שחסר מספר טלפון ללקוח\nיש להפנות את הלקוח לאזור האישי לעדכון מספר טלפון https://app.passportcard.co.il/SelfService או באמצעות נציג בטלפון *9912",
      t_messageDifferentPhone:
        "שמנו לב שהטלפון שהזנת שונה מהטלפון שמופיע במערכת.... יש לעדכן את הטלפון דרך האיזור האישי...",
      t_login_error: "מספר תעודת הזהות או מספר הטלפון שהזנת אינם תקינים",
      t_no_results_found: "לא נמצאו תוצאות",
      acc_t_no_results_found: "לֹא נִמְצָאו תוּצָאוֹת",
      t_card_details_first_name: "שם פרטי",
      t_card_details_id: "תעודת זהות",
      t_card_holder_details: "פרטי בעל הכרטיס",
      t_iframe_response_1:
        "הכרטיס שהזנת אינו תקין, אנא בחר כרטיס אחר או הזן כרטיס חדש",
      t_iframe_response_2:
        "הכרטיס שהזנת תוקפו יפוג במהלך הנסיעה ולכן לא ניתן להשתמש בו לשירותי PassportCard plus , יש לבחור כרטיס אחר או לעדכן פרטי כרטיס אשראי חדש מסוג ויזה או מאסרטכארד",
      t_iframe_response_3:
        "לשימוש בשרותי PassportCard plus יש לבחור כרטיס אחר או לעדכן כרטיס אשראי מסוג ויזה או מאסטרקארד על שם מבקש השירות",
      t_iframe_response_4:
        "לשימוש בשרותי PassportCard plus יש לבחור כרטיס אחר או לעדכן כרטיס אשראי מסוג ויזה או מאסטרקארד על שם מבקש השירות",
      t_iframe_response_5:
        "לשימוש בשרותי PassportCard plus , יש לבחור כרטיס אחר או לעדכן כרטיס אשראי ישראלי על שם מבקש השירות",
      t_iframe_response_6:
        "לשימוש בשרותי PassportCard plus , יש לבחור כרטיס אחר או לעדכן כרטיס אשראי שאינו כרטיס דביט על שם מבקש השירות",
      t_iframe_response_7:
        "לשימוש בשרותי PassportCard plus , יש לבחור כרטיס אחר או לעדכן כרטיס אשראי ישראלי ושאינו כרטיס דביט על שם מבקש השירות",
      t_inquire_cg_iframe_result_error:
        "הכרטיס שהזנת אינו תקין, אנא בחר כרטיס אחר או הזן כרטיס חדש",
      t_inquire_cg_iframe_result_error_no_cards:
        "הכרטיס שהזנת אינו תקין, אנא הזן כרטיס חדש",
      t_cg_inquiry_cg_iframe_failed:
        "שגיאה כללית, ניתן להתקשר למוקד השירות בטלפון *9912",
      t_cg_no_iframe_url: "שגיאה כללית, ניתן להתקשר למוקד השירות בטלפון *9912",
      t_card_details: "פרטי כרטיס",
      t_login_general_error_title: "אופס, משהו השתבש",
      t_login_general_error_text:
        "שגיאה כללית, ניתן להתקשר למוקד השירות בטלפון *9912",
      t_otp_invalid_code: "הקוד שהזנת שגוי, נא לנסות שוב",
      t_otp_expired_code: "הקוד שהזנת פג תוקף. נא לשלוח קוד חדש",
      t_otp_blocked_user:
        "מתנצלים, לאחר 3 ניסיונות המשתמש נחסם למשך 5 דקות. נא לנסות שוב",
      t_otp_one_or_more_wrong_fields:
        "נראה שאחד או יותר מהפרטים שהוזנו אינם נכונים. אנא בדקו את הפרטים ונסו שוב",
      t_leads_transferring_error_message:
        "שגיאה כללית, ניתן להתקשר למוקד השירות בטלפון *9912",

      t_active_credit_card_brand_not_authorized:
        "שירותי PassportCard plus תומכים בכרטיסים מסוג ויזה או מאסטרכארד",
      acc_t_active_credit_card_brand_not_authorized:
        "שֵׁירוּתֵי פַּאסְ פּוֹרְט קַארְד פְּלוּס תּוֹמְכִים בִּכְרְטִיסִים מִסּוּג וִיזָה אוֹ מַאסְטֶרְקַארְד",
      t_active_credit_card_will_expire:
        "הכרטיס שעודכן תוקפו יפוג במהלך הנסיעה ולכן לא ניתן להשתמש בו לשירותי PassportCard plus",
      t_active_credit_personal_id_mismatch:
        "לשימוש בשירותי PassportCard plus נדרש כרטיס אשראי מסוג ויזה או מאסטרכארד על שם מבקש השירות",
      t_active_credit_debit_card:
        "לשימוש בשירותי PassportCard plus נדרש כרטיס אשראי שאינו דביט על שם מבקש השירות",
      t_active_credit_not_israeli_card:
        "לשימוש בשירותי PassportCard plus נדרש כרטיס אשראי ישראלי על שם מבקש השירות",
      t_active_credit_not_israeli_and_debit_card:
        "לשימוש בשירותי PassportCard plus נדרש כרטיס אשראי ישראלי שאינו דביט על שם מבקש השירות",

      t_active_credit_card_brand_not_authorized_other_cards:
        "שירותי PassportCard plus תומכים בכרטיסים מסוג ויזה או מאסטרכארד. יש לבחור כרטיס אחר או לעדכן כרטיס מסוג זה לשימוש בשירות",
      t_active_credit_card_will_expire_other_cards:
        "הכרטיס שעודכן תוקפו יפוג במהלך הנסיעה ולכן לא ניתן להשתמש בו לשירותי PassportCard plus. יש לבחור כרטיס אחר או לעדכן פרטי כרטיס אשראי חדש מסוג ויזה או מאסטרכארד",
      t_active_credit_personal_id_mismatch_other_cards:
        "לשימוש בשירותי PassportCard plus, יש לבחור כרטיס אחר או לעדכן כרטיס אשראי מסוג ויזה או מאסטרכארד על שם מבקש השירות",
      t_active_credit_debit_card_other_cards:
        "לשימוש בשירותי PassportCard plus, יש לבחור כרטיס אחר שאינו דביט והינו על שם מבקש השירות",
      t_active_credit_card_general_error_other_cards: "",
      t_active_credit_not_israeli_card_other_cards:
        "לשימוש בשירותי PassportCard plus, יש לבחור כרטיס אחר או לעדכן כרטיס אשראי ישראלי על שם מבקש השירות",
      t_active_credit_not_israeli_and_debit_card_other_cards:
        "לשימוש בשירותי PassportCard plus, יש לבחור כרטיס אחר שאינו דביט או לעדכן כרטיס אשראי ישראלי על שם מבקש השירות",
      t_active_credit_general_error:
        "מצטערים, משהו השתבש עם הכרטיס שעודכן בעת רכישת הפוליסה , אנא בחר כרטיס אחר או הוסף כרטיס מסוג ויזה או מאסטרכארד",
      t_must_list_title: "הלקוח צורף לשירות בהצלחה!",
      acc_t_must_list_title: "הַלָּקוֹחַ צוֹרַף לַשֵּׁירוּת בְּהַצְלָחָה!",
      t_must_list_sub_title: "דגשים להקראה ללקוח:",
      acc_t_must_list_sub_title: "דְּגָשִׁים לְהַקְרָאָה לַלָּקוֹחַ:",
      t_must_list_body_question_1:
        "פתחתי את כרטיס ה PassportCard  לשימושים בחו״ל, כל חיוב שלך בכרטיס ה-PassportCard יחויב מכרטיס אשראי הפרטי המסתיים ב-XXXX",
      acc_t_must_list_body_question_1:
        "פָּתַחְתִּי אֶת כַּרְטִיס הַפַּאסְ פּוֹרְט קַארְד לִשְׁימוּשִׁים בַּחוּ״ל.",
      t_must_list_body_question_2_collect:
        "כרטיס ה PassportCard שברשותך אינו תומך בשירות ה-plus , חשוב לאסוף כרטיס חדש בנקודת האיסוף בנתב״ג",
      t_must_list_body_question_2_replace:
        "מזכירים לך לאסוף את הכרטיס לפני הנסיעה, בנקודת האיסוף או בנתב״ג.",
      t_must_list_body_question_2_use_existing:
        "ברשותך כרטיס PassportCard פעיל מנסיעותייך הקודמות המסתיים ב - XXXX חשוב לקחת אותו לנסיעותך הקרובה",
      acc_t_must_list_body_question_2_collect:
        "כרטיס ה-PassportCard שברשותך אינו תומך בשירות ה-Plus, חָשׁוּב לֶאֱסוֹף כרטיס חדש בנקודת האיסוף בנתב״ג.",
      acc_t_must_list_body_question_2_replace:
        "מַזְכִּירִים לְךָ לֶאֱסוֹף אֶת הַכַּרְטִיס לִפְנֵי הַנְּסִיעָה, בְּנְקוּדַּת הָאִיסּוּף אוֹ בְּנָתְבּ״ג.",
      acc_t_must_list_body_question_2_use_existing:
        "בְּרְשׁוּתְךָ כַּרְטִיס PassportCard פָּעִיל מִנְּסִיעוֹתֶיךָ הַקּוֹדְמוֹת, הַמִּסְתַּיֵּם בְּ- XXXX. חָשׁוּב לָקַחַת אוֹתוֹ לִנְסִיעָתְךָ הַקְּרוֹבָה.",
      t_must_list_body_question_3:
        "פתיחת הכרטיס מותנית בהפעלה ראשונית של הכרטיס ואישור תנאי השימוש בשירות באמצעות האפליקציה שלנו בשם PassportCard il. הקוד הסודי של הכרטיס ימתין לך באפליקציה",
      acc_t_must_list_body_question_3:
        "פְּתִיחַת הַכַּרְטִיס מֻתְנֵית בְּהַפְעָלָה רִאשׁוֹנִית שֶׁל הַכַּרְטִיס וְאִישּׁוּר תַּנָּאֵי הַשִּׁימוּשׁ בַּשֵּׁירוּת בְּאֶמְצָעוּת הָאֲפְּלִיקַצְיָה שֶׁלָּנוּ בְּשֵׁם פַּאסְ פּוֹרְט קַארְד אִי אֶל. הַקוֹד הַסּוֹדִי שֶׁל הַכַּרְטִיס יַמְתִּין לְךָ בָּאֲפְּלִיקַצְיָה",
      t_must_list_body_question_4:
        "השירות יופעל אוטומטית בכרטיס ה PassportCard שלך בכל פעם שתרכוש בעתיד את ביטוח הנסיעות של הPassportCard (תקופת השירות)",
      acc_t_must_list_body_question_4:
        "הַשֵּׁירוּת יוּפְעַל אוֹטוֹמָטִית בַּכַּרְטִיס הַפַּאסְ פּוֹרְט קַארְד שֶׁלְּךָ בְּכָל פַּעַם שֶׁתִּרְכּוֹשׁ בֶּעָתִיד אֶת בִּטּוּחַ הַנְּסִיעוֹת שֶׁל הַפַּאסְ פּוֹרְט קַארְד (תְּקוּפַּת הַשֵּׁירוּת)",
      t_must_list_body_question_5:
        "השירות יופעל אוטומטית בכרטיס ה- PassportCard שלך בכל פעם שתרכוש בעתיד את ביטוח הנסיעות של PassportCard",
      acc_t_must_list_body_question_5:
        "הַשֵּׁירוּת יוּפְעַל אוֹטוֹמָטִית בַּכַּרְטִיס הַפַּאסְ פּוֹרְט קַארְד שֶׁלְּךָ בְּכָל פַּעַם שֶׁתִּרְכּוֹשׁ בֶּעָתִיד אֶת בִּטּוּחַ הַנְּסִיעוֹת שֶׁל פַּאסְ פּוֹרְט קַארְד",
      t_must_list_body_question_6:
        "לידעתך קיימות מגבלות שונות על השימוש בכרטיס המפורטות בתנאי השימוש ובאפליקציה. במייל שישלח אליך מיד לאחר שיחה זו, ניתן למצוא מידע נוסף על השירות.",
      acc_t_must_list_body_question_6:
        "לִידִיעָתְּךָ קַיָּימוֹת מִגְבָּלוֹת שׁוֹנוֹת עַל הַשִּׁימוּשׁ בַּכַּרְטִיס הַמְּפוֹרָטוֹת בְּתַנָּאֵי הַשִּׁימוּשׁ וּבָאֲפְּלִיקַצְיָה. בַּמֵּיְיל שֶׁיֵּשָׁלַח אֵלֶיךָ מִיָּד לְאַחַר שִׂיחָה זוֹ, נִתָּן לִמְצֹוא מֵידָע נוֹסָף עַל הַשֵּׁירוּת",
      t_must_list_body_question_7: 'השירות ניתן על ידי שירותים פיננסיים בע"מ',
      acc_t_must_list_body_question_7:
        'הַשֵּׁירוּת נִיתָּן עַל יְדֵי שֵׁירוּתִים פִּינַנְסִיִּים בַּעַ"ם',
      t_must_list_body_question_8:
        "באפשרותך לקבל ברקוד להחזרי מעמ באמצעות רישום באפליקציה",
      acc_t_must_list_body_question_8:
        'בְּאֶפְשָׁרוּתְךָ לְקַבֵּל בַּרְקוֹד לְהַחְזָרֵי מַעַ"ם בְּאֶמְצָעוּת רִישּׁוּם בָּאֲפְּלִיקַצְיָה',
      t_must_list_body_question_9:
        "כל מה שנשאר זה להוריד את האפליקציה, להפעיל את הכרטיס ולהנות.",
      acc_t_must_list_body_question_9:
        "כָּל מָה שֶׁנִּשְׁאַר זֶה לְהוֹרִיד אֶת הָאֲפְּלִיקַצְיָה, לְהַפְעִיל אֶת הַכַּרְטִיס וּלְהֵנּוֹת",
      t_must_list_accept_text: "אני מאשר שהודעתי ללקוח",
      acc_t_must_list_accept_text: "אֲנִי מְאַשֵּׁר שֶׁהוֹדַעְתִּי לַלָּקוֹחַ",
      t_must_list_accept_button: "סיום",
      acc_t_must_list_accept_button: "סִיּוּם",
      t_footer_accessibility_statement: "הצהרת נגישות",
      t_footer_privacy_policy: "מדיניות הפרטיות",
      t_footer_terms_of_use: "תנאי השימוש",
      t_footer_security_statement: "האתר מאובטח בכפוף ל",
      t_must_list_error_message:
        "מצטערים, משהו השתבש. נשמח אם תנסו שוב בעוד כמה רגעים",
      acc_t_must_list_error_message:
        "מִצְטַעֲרִים, מַשֶּׁהוּ הִשְׁתַּבֵּשׁ. נִשְׂמַח אִם תְּנַסּוּ שׁוּב בְּעוֹד כַּמָּה רְגָעִים",
      t_global_blue_sub_title:
        "אל דאגה!  אפשר לבצע את הרישום גם מאוחר יותר באפליקציה",
      acc_t_global_blue_sub_title:
        "אַל דְּאָגָה! אֶפְשָׁר לְבַצֵּעַ אֶת הַרִּישּׁוּם גַּם מְאוּחָר יוֹתֵר בָּאֲפְּלִיקַצְיָה.",
      t_global_blue_accordion_title: 'רישום לספק החזרי מע"מ',
      acc_t_global_blue_accordion_title: "רִישּׁוּם לְסַפָּק הַחְזָרֵי מַע״מ.",
      t_global_blue_checkbox_text:
        "<span> בהרשמתך לשירות החזרי מע״מ, הנך מסכים/ה לקבלת השירות באמצעות <a href='https://www.globalblue.com/en/shoppers/legal-information/privacy-policy' target='_blank' rel='noopener noreferrer'>Global Blue</a> ו- <a href='https://www.passportcard.co.il/privacy-policy' target='_blank' rel='noopener noreferrer'>PassportCard Tax free</a>. מתן השירות כפוף למדיניות הפרטיות והשימוש של ספקים אלו. </span>",
      t_global_blue_success_title: "הרשמה ל-Global Blue הושלמה בהצלחה!",
      acc_t_global_blue_success_title:
        "הַרְשָׁמָה ל־Global Blue הוּשְׁלְמָה בְּהַצְלָחָה!",
      t_global_blue_success_subtitle: "שימו לב להנחיות להמשך",
      acc_t_global_blue_success_subtitle:
        "שִׂימוּ לֵב לַהַנְחָיוֹת לַהַמְשֵׁךְ.",
      t_active_credit_card_error_message:
        "מצטערים, משהו השתבש. נשמח אם תנסו שוב בעוד כמה רגעים",
      acc_t_active_credit_card_error_message:
        "מִצְטַעֲרִים, מַשֶּׁהוּ הִשְׁתַּבֵּשׁ. נִשְׂמַח אִם תְּנַסּוּ שׁוּב בְּעוֹד כַּמָּה רְגָעִים",
      t_tax_refund_RC_1:
        "איזה יופי - אנחנו מזהים כי הנך כבר רשום לשירות - לקבלת ברקוד יש לפנות לחברת GB בלינק הבא",
      t_tax_refund_RC_2: "נראה שעבר יותר מידי זמן. יש לנסות שוב..",
      t_tax_refund_RC_3:
        "אופס! נראה שיש בעיה בתהליך הרישום , ניתן לנסות שוב באפליקציה",
      t_tax_refaund_general_error_message:
        "מצטערים, משהו השתבש. נשמח אם תנסו שוב בעוד כמה רגעים",
      t_active_credit_active_card: "כרטיס פעיל",
      t_active_credit_not_active_card: "כרטיס לא פעיל",
      t_global_blue_sub_title_1:
        'קיצרנו עבורך את תהליך ההרשמה לספק החזרי המע"מ',
      acc_t_global_blue_sub_title_1:
        "קִיצַּרְנוּ עֲבוּרְךָ אֶת תַּהֲלִיךְ הַהַרְשָׁמָה לְסַפָּק הַחְזָרֵי הַמַּע״מ.",
      t_global_blue_sub_title_2: "כותרת משנה שניה",
      acc_t_global_blue_sub_title_2: "כּוֹתֶרֶת מִשְׁנָה שְּׁנִיָּה.",
      t_global_blue_sub_title_3: "כותרת משנה שלישית",
      acc_t_global_blue_sub_title_3: "כּוֹתֶרֶת מִשְׁנָה שְּׁלִישִׁית.",
      t_tax_refund_general_error_title: "אופס!",
      generalErrorIframeSessionExpired: "עבר קצת זמן",
      generalErrorIframeContinueViaApp:
        'ניתן להמשיך רישום להחזר מע"מ באמצעות האפליקציה. רוצה ליצור איתנו קשר?\nאנחנו זמינים עבורך בטלפון מספר 9912* או בוואטסאפ מספר 050-6708544',
      t_tax_refund_general_error_message:
        "מצטערים, משהו השתבש. נשמח אם תנסו שוב בעוד כמה רגעים",
      acc_t_clear_field: "נַקֵּה אֶת הַשָּׂדֶה",
      aria_t_passengers: "מספר הדרגות",
      t_digital_agent_checkbox_text:
        "אני מאשר/ת כי הלקוח נתן הסכמתו להעביר את פרטיו לחברת פספורטכארד שירותים פיננסיים לצורך הצעה לשירותים פיננסיים (PassportCard Pay)",
      t_pc_plus_title: "הצטרפות לשירות PassportCard Pay",
      acc_t_pc_plus_title:
        "הַצְטָרְפוּת לַשֵּׁירוּת פַּאסְ פּוֹרְט קַארְד פְּלוּס",
      t_pc_plus_what_the_service_includes_title:
        'משלמים בחו"ל עם הכרטיס ונהנים מ:',
      acc_t_pc_plus_what_the_service_includes_title: "מָה הַשֵּׁירוּת כּוֹלֵל?",
      acc_t_pc_plus_what_the_service_includes_sub_title:
        "מֵעַכְשָׁיו, כַּרְטִיס הַפַּאסְ פּוֹרְט קַארְד שֶׁלְּךָ יָכוֹל לְשַׁמֵּשׁ אוֹתְךָ גַּם לְהוֹצָאוֹת הַנְּסִיעָה, וּלְאַפְשֵׁר לְךָ לֵיהָנוֹת מִמִּסְפָּר הַטָּבוֹת יִיחוּדִיּוֹת",
      t_pc_plus_what_the_service_includes_list_item_title_1: "AI Protector",
      t_pc_plus_what_the_service_includes_list_item_title_2: ' החזרי מע"מ',
      t_pc_plus_what_the_service_includes_list_item_title_3:
        "אפליקציית PassportCard Pay",
      t_pc_plus_what_the_service_includes_list_item_sub_title_1:
        "טכנולוגיה ייחודית המגנה עליך מעמלות כפולות ונסתרות בקניות ומשיכת כסף מכספומטים",
      t_pc_plus_what_the_service_includes_list_item_sub_title_2:
        'סוכן השופינג שלך יסייע לך בקבלת החזרי מע"מ על הקניות בחו"ל',
      t_pc_plus_what_the_service_includes_list_item_sub_title_2_option_1:
        "<b>איך</b> לעשות ומה לבקש",
      t_pc_plus_what_the_service_includes_list_item_sub_title_2_option_2:
        "<b>לאן</b> להגיע בשדה התעופה",
      t_pc_plus_what_the_service_includes_list_item_sub_title_2_option_3:
        "<b>מהו</b> ההחזר הכספי הצפוי",
      t_pc_plus_what_the_service_includes_list_item_sub_title_3:
        'הפעלת השירות דרך האפליקציה מאפשרת לך לעקוב אחר הקניות בחו"ל, לראות כמה חסכת וכמה החזר מע"מ מגיע לך',
      t_pc_plus_what_the_service_includes_footer_title: "מה צריך לעשות?",
      t_pc_plus_what_the_service_includes_footer_option1:
        "נרשמים לשירות PassportCard Pay",
      t_pc_plus_what_the_service_includes_footer_option2:
        "מחברים את כרטיס האשראי הפרטי לשירות",
      t_pc_plus_what_the_service_includes_footer_option3:
        'משלמים באמצעות הכרטיס על הקניות בחו"ל',
      t_pc_plus_next_button: "להרשמה לשירות >",
      acc_t_pc_plus_next_button: "לְהַרְשָׁמָה לַשֵּׁירוּת",
      t_activate_creditCard_point1: "מחברים את כרטיס האשראי הפרטי שלך לשירות",
      acc_t_activate_creditCard_point1:
        "מְחַבְּרִים אֶת כַּרְטִיס הָאַשְׁרַאי הַפְּרָטִי שֶׁלְּךָ לַשֵּׁירוּת",
      t_activate_creditCard_point2:
        'משלמים באמצעות כרטיס ה-PassportCard שלך בכל רכישה בחו"ל',
      acc_t_activate_creditCard_point2:
        "מְשַׁלְּמִים בְּאֶמְצָעוּת כַּרְטִיס הַפַּאסְ פּוֹרְט קַארְד שֶׁלְּךָ בְּכָל רְכִישָׁה בַּחוּ״ל",
      t_activate_creditCard_point3:
        "כרטיס האשראי שלך יחויב בסכום הרכישות בשקלים",
      acc_t_activate_creditCard_point3:
        "כַּרְטִיס הָאַשְׁרַאי שֶׁלְּךָ יְחֻיָּב בִּסְכוּם הָרְכִישׁוֹת בַּשְּׁקָלִים",
      t_activate_creditCard_point4: "עוקבים בקלות אחר הוצאות הנסיעה באפליקציה",
      acc_t_activate_creditCard_point4:
        "עוֹקְבִים בְּקַלּוּת אַחַר הוֹצָאוֹת הַנְּסִיעָה בָּאֲפְּלִיקַצְיָה",
      t_activate_creditCard_point5:
        "השירות יופעל אוטומטית בכל רכישת ביטוח נסיעות של PassportCard, למשך תקופת הביטוח",
      acc_t_activate_creditCard_point5:
        "הַשֵּׁירוּת יוּפְעַל אוֹטוֹמָטִית בְּכָל רְכִישַׁת בִּיטּוּחַ נְסִיעוֹת שֶׁל פַּאסְ פּוֹרְט קַארְד, לִמְשֶׁךְ תְּקוּפַּת הַבִּיטּוּחַ",
      t_passportCard_il: "PassportCard IL",
      t_card_restrictions_button: "למידע נוסף על מגבלות השימוש בכרטיס",
      acc_t_card_restrictions_button:
        "לְמֵידָע נוֹסָף עַל מִגְבָּלוֹת הַשִּׁמּוּשׁ בַּכַּרְטִיס.",
      t_summary_screen_qr_code_ready:
        "הברקוד להחזרי המע׳׳מ שלך כבר מחכה לך באפליקציה !",
      acc_t_summary_screen_qr_code_ready:
        "הַבְּרָקוּד לְהַחְזֵרִים הַמַּעְגְּלִים שֶׁלְּךָ כְּבָר מַחֲכִית לְךָ בְּאֶפְלִיקְצִיָּה !",
      t_active_checkbox_label:
        "אני מאשר/ת שקראתי את תנאי השימוש בשירות ואת תעריפי השירות הנלווים, ואני מסכים/ה להם.",
      t_activate_credit_card_termsOfService: "תנאי השימוש בשירות",
      t_activate_credit_card_servicePricing: "תעריפי השירות",
      t_tax_refund_termsOfService: "תנאי השימוש בשירות",
      t_tax_refund_servicePricing: "תעריפי השירות",
      acc_t_tax_refaund_policy_text:
        "מְדִינִיּוּת הַפְּרָטִיּוּת וְהַשִּׁימוּשׁ",
      acc_t_tax_refaund_3rd_party_policy_text: "סַפָּק צַד שְׁלִישִׁי",
      acc_cell_number: "תא מספר",
      acc_enter: "הכנס",
      acc_numbers: "ספרות",
      acc_for_policy_choice: "לבחירת פוליסה",
      acc_for: "עבור",
      t_update_contact_email_not_valid: "אימייל לא תקין",
      t_update_contact_validation_wrong_apartment: "מספר בית לא תקין",
      t_update_contact_validation_wrong_apartment_max_length:
        "יש להזין עד 4 ספרות",
      t_tax_refaund_validation_wrong_passport: "מספר דרכון לא תקין",
      t_tax_refund_expiration_date: "תוקף",
      t_401_error_popup_title: "חלף זמן",
      t_401_error_popup_body:
        "נראה שעבר יותר מידי זמן.. אנחנו כאן עבורך , באפשרותך ליצור איתנו קשר בכל דרך שנוחה לך ואנחנו נפתור את הבעיה בהקדם ובטלפון *9912 financialservices@passportcard.co.il אנו זמינים עבורך במייל תודה על ההבנה",
      t_401_error_popup_find_button: "להמשך הצטרפות לשירות לחץ כאן",
      t_risk_country_info_text: "קיימת מגבלת שימוש של 5000 ש׳׳ח ביעדך",
      t_wrong_otp_error: "קוד האימות אינו תקין",
      t_digit_entry_message:
        "אנא הזן {{maxLength}} ספרות. הוזנו {{enteredLength}} מתוך {{maxLength}} ספרות.",
      t_otp_format: "קוד האימות שלך הוא: @&#123;&#125;",
      somethingWentWrong: "משהו השתבש, יש לנסות שוב מאוחר יותר",
      t_active_credit_card_fx_general_error:
        "מצטערים, משהו השתבש עם הכרטיס שעודכן בעת רכישת הפוליסה, אנא בחר כרטיס אחר או הוסף כרטיס מסוג ויזה או מאסטרכארד",
      t_active_credit_card_fx_general_error_other_cards:
        "מצטערים, משהו השתבש, אנא הוסף כרטיס מסוג ויזה או מאסטרכארד על שם מבקש השירות",

      t_active_credit_card_fx_brand_not_authorized:
        "הכרטיס שעודכן בעת רכישת הפוליסה אינו מסוג ויזה או מאסטרקארד ולכן לא ניתן להשתמש בו לשירותי PassportCard plus, יש לעדכן פרטי כרטיס אשראי חדש מסוג ויזה או מאסטרכארד על שם מבקש השירות",
      t_active_credit_card_fx_brand_not_authorized_other_cards:
        "הכרטיס שעודכן בעת רכישת הפוליסה אינו מסוג ויזה או מאסטרקארד ולכן לא ניתן להשתמש בו לשירותי PassportCard plus , יש לבחור כרטיס אחר או לעדכן פרטי כרטיס אשראי חדש מסוג ויזה או מאסטרקארד על שם מבקש השירות",

      t_active_credit_card_fx_will_expire:
        "הכרטיס שעודכן בעת רכישת הפוליסה תוקפו יפוג במהלך הנסיעה ולכן לא ניתן להשתמש בו לשירותי PassportCard pay , יש לבחור כרטיס אחר או לעדכן פרטי כרטיס אשראי חדש מסוג ויזה או מאסרטכארד",

      t_active_credit_card_fx_personal_id_mismatch:
        "הכרטיס שעודכן בעת רכישת הפוליסה אינו על שם מבקש השירות ולכן לא ניתן להשתמש בו לשירותי PassportCard plus , יש לעדכן פרטי כרטיס אשראי חדש על שם מבקש השירות",
      t_active_credit_card_fx_personal_id_mismatch_other_cards:
        "הכרטיס שעודכן בעת רכישת הפוליסה אינו על שם מבקש השירות ולכן לא ניתן להשתמש בו לשירותי PassportCard plus , יש לבחור כרטיס אחר או לעדכן פרטי כרטיס אשראי חדש על שם מבקש השירות",

      t_active_credit_card_fx_not_israeli_card:
        "הכרטיס שעודכן בעת רכישת הפוליסה אינו כרטיס אשראי ישראלי ולכן לא ניתן להשתמש בו לשירותי PassportCard plus , יש לעדכן פרטי כרטיס אשראי ישראלי על שם מבקש השירות",
      t_active_credit_card_fx_not_israeli_card_other_cards:
        "הכרטיס שעודכן בעת רכישת הפוליסה אינו כרטיס אשראי ישראלי ולכן לא ניתן להשתמש בו לשירותי PassportCard plus , יש לבחור כרטיס אחר או לעדכן פרטי כרטיס אשראי ישראלי על שם מבקש השירות",

      t_active_credit_card_fx_debit_card:
        "הכרטיס שעודכן בעת רכישת הפוליסה הינו כרטיס דביט ולכן לא ניתן להשתמש בו לשירותי PassportCard plus , יש לעדכן פרטי כרטיס אשראי חדש שאינו דביט ועל שם מבקש השירות",
      t_active_credit_card_fx_debit_card_other_cards:
        "הכרטיס שעודכן בעת רכישת הפוליסה הינו כרטיס דביט ולכן לא ניתן להשתמש בו לשירותי PassportCard plus , יש לבחור כרטיס אחר או לעדכן פרטי כרטיס אשראי חדש שאינו דביט ועל שם מבקש השירות",

      t_active_credit_card_fx_debit_and_not_israeli:
        "הכרטיס שעודכן בעת רכישת הפוליסה הינו כרטיס דביט ואינו ישראלי ולכן לא ניתן להשתמש בו לשירותי PassportCard plus , יש לעדכן פרטי כרטיס אשראי חדש שאינו דביט / ישראלי על שם מבקש השירות",
      t_active_credit_card_fx_debit_and_not_israeli_other_cards:
        "הכרטיס שעודכן בעת רכישת הפוליסה הינו כרטיס דביט ואינו ישראלי ולכן לא ניתן להשתמש בו לשירותי PassportCard plus , יש לבחור כרטיס אחר או לעדכן פרטי כרטיס אשראי חדש שאינו דביט / ישראלי על שם מבקש השירות",
      t_tax_refaund_yellow_banner_title:
        "לידיעתך , במידה ויהיו החזרי מע׳׳מ הם יוחזרו לכרטיס האשראי המחובר לשירות",
      t_leads_transferring_title_success: "נשלח sms ללקוח",
      t_please_select_from_the_list: "יש לבחור מהרשימה בלבד",
    },
  },
};
